// src/js/modules/dynamic-header.js

const initDynamicHeader = () => {
  // Usamos una clase 'js-header' como hook para el JS
  const siteHeader = document.querySelector(".js-header");
  if (!siteHeader) return;

  let lastScrollY = window.scrollY;
  let isThrottled = false;

  const handleScroll = () => {
    if (!isThrottled) {
      window.requestAnimationFrame(() => {
        const currentScrollY = window.scrollY;

        // Solo ocultamos si se ha hecho scroll más allá de la altura del propio header
        if (currentScrollY > siteHeader.offsetHeight) {
          if (currentScrollY > lastScrollY) {
            // Scroll hacia abajo -> ocultar
            siteHeader.classList.add("is-hidden");
          } else {
            // Scroll hacia arriba -> mostrar
            siteHeader.classList.remove("is-hidden");
          }
        } else {
          // Si estamos en la parte superior, siempre se muestra
          siteHeader.classList.remove("is-hidden");
        }

        lastScrollY = currentScrollY;
        isThrottled = false;
      });
      isThrottled = true;
    }
  };

  window.addEventListener("scroll", handleScroll);
};

export default initDynamicHeader;
